













































































































































import { Component, Emit, Vue } from 'vue-property-decorator';
import TaftImageAnimated from '@/components/base-layout/TaftImageAnimated.vue';
import TaftModal from '@/components/taft-modal/TaftModal.vue';

@Component({
  components: {
    TaftModal,
    TaftImageAnimated,
  },
})
export default class PrivacyPolicyModal extends Vue {
  showModal = false;

  show() {
    this.showModal = true;
  }

  @Emit('close')
  close() {
    this.showModal = false;
  }
}
